var map = {
	"./1.png": 18067,
	"./2.png": 96866,
	"./3.png": 67476,
	"./4.png": 2845,
	"./5.png": 77326,
	"./6.png": 5203,
	"./7.png": 99219,
	"./8.png": 31344,
	"./9.png": 28247,
	"./icon.jpg": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14596;